import React, { useState } from 'react';
import { __ } from 'i18n/index';
import { applySiteTheme, THEME_DARK, THEME_LIGHT } from 'functions/siteTheme';

// Dev-only testing aid for the light theme: one user-menu row that flips
// Dark/Light. The server sends it props only off production
// (services\layout\SiteHeaderProps::devThemeSwitch); Account Settings is where
// players choose a theme. It applies at once and saves through the same
// preferences endpoint the settings picker uses; a failed save puts the
// previous theme back.
export default function DevThemeSwitch({ initialTheme }) {
	const [theme, setTheme] = useState(initialTheme === THEME_LIGHT ? THEME_LIGHT : THEME_DARK);

	const switchTheme = (event) => {
		event.preventDefault();
		const previousTheme = theme;
		const nextTheme = theme === THEME_LIGHT ? THEME_DARK : THEME_LIGHT;
		setTheme(nextTheme);
		applySiteTheme(nextTheme);
		// Loaded on click so the header bundle (and its server render) stays
		// free of the request code.
		return import(/* webpackChunkName: "accountSettingsRequests" */ 'react/settings/AccountSettings/accountSettingsRequests')
			.then(({ savePreferences }) => savePreferences({ theme: nextTheme }))
			.catch(() => {
				setTheme(previousTheme);
				applySiteTheme(previousTheme);
			});
	};

	const label = theme === THEME_LIGHT ? __('Light') : __('Dark');
	const switchTo = theme === THEME_LIGHT ? __('Switch to dark theme') : __('Switch to light theme');

	return (
		<li>
			<a href='#' role='button' className='header-menu__dev-theme' title={switchTo} onClick={switchTheme}>
				<span className='ico'><i className={`fa ${theme === THEME_LIGHT ? 'fa-sun-o' : 'fa-moon-o'}`}></i></span>
				{__('Theme')}: {label}
				<span className='header-menu__row-aside header-menu__dev-badge'>dev</span>
			</a>
		</li>
	);
}
